import styled from "styled-components";

export const PlanDetailsWrapper = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",

    ".plan-details-header": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem",
      paddingBottom: "1rem",
      borderBottom: "1px solid #e0e0e0",

      ".header-left, .header-right": {
        flex: 0,
      },

      "& button": {
        backgroundColor: "transparent",
        gap: "0.5rem",
        color: "var(--color-primary)",
        border: "1px solid var(--color-primary)",
        padding: "0.5rem 1rem",
        borderRadius: "0.5rem",
        width: "fit-content",
        display: "flex",
        marginBottom: "0.5rem",
        "&:hover": {
          backgroundColor: "var(--color-primary-hover)",
          color: "var(--color-primary)",
          border: "1px solid var(--color-primary-hover)",
        },
      },

      ".header-center": {
        display: "flex",
        gap: "1rem",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        "& button": {
          backgroundColor: "transparent",
          color: "var(--color-primary)",
          height: "fit-content",
          "&:hover": {
            backgroundColor: "var(--color-primary-hover)",
          }
        }
      },


      ".header-right button": {
        backgroundColor: "transparent",
        color: "white",
        border: "none",
        "&:hover": {
          backgroundColor: "var(--color-primary-hover)",
        },
      },
    },

    ".plan-summary": {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "1rem",
      padding: "1.5rem",
      borderRadius: "1rem",
      border: "1px solid var(--color-primary-hover)",
      background: "var(--color-background)",
      "& label": {
        fontWeight: "bold",
      },
    },

    ".plan-summary-header": {
      width: "100%",
    },

    ".plan-boolean-grid": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: "1rem",
      padding: "1.5rem",
      borderRadius: "1rem",
      border: "1px solid var(--color-primary-hover)",
      background: "var(--color-background-secondary)",
      "& label": {
        fontWeight: "bold",
      },
    },

    ".plan-boolean-grid > div, .plan-summary > div": {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
    },

    ".plan-features-table": {
      padding: "1.5rem",
      borderRadius: "1rem",
      border: "1px solid var(--color-primary-hover)",
      background: "var(--color-background-secondary)",
      overflowX: "auto",
      "& h3": {
        fontWeight: "bold",
        marginBottom: "1rem",
      },
    },

    ".plan-features-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      borderRadius: "0.5rem",
      border: "1px solid var(--color-primary-hover)",
      minWidth: "100%",
      tableLayout: "auto",
      overflow: "hidden",
      "& thead": {
        borderRadius: "0.5rem 0.5rem 0 0",
      },
    },

    ".plan-features-table th": {
      color: "var(--color-primary)",
      backgroundColor: "var(--color-primary-hover)",
      "&:first-child": {
        borderTopLeftRadius: "0.5rem",
      },
      "&:last-child": {
        borderTopRightRadius: "0.5rem",
      },
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },

    ".plan-features-table td": {
      textAlign: "left",
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },

    ".plan-features-table tbody tr:nth-child(odd)": {
      background: "var(--color-background)",
    },

    "@media screen and (max-width: 768px)": {
      ".plan-summary": {
        gridTemplateColumns: "1fr",
      },
      ".plan-boolean-grid": {
        gridTemplateColumns: "1fr",
      },
      ".plan-details-header": {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "0.5rem",

        ".header-center": {
          textAlign: "left",
        },
      },
      ".plan-features-table": {
        padding: "1rem",
      },
      ".plan-features-table table": {
        minWidth: "unset",
      },
      ".plan-features-table th, .plan-features-table td": {
        padding: "0.75rem 0.8rem",
      },
    },
  };
});
